export default __webpack_public_path__ + "static/headstand-variations-2-900042973ca4a6de5ce0b9601ab5ddae.jpg";